import moment from 'moment'
import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { trackEcommerce } from '../../gtm'
import { roundPrice } from '../../utils'
import { convertCurrency, DateFormat } from '../helpers'
import ItineraryPopup from '../popups/ItineraryPopup'
import Cabins from './Cabins'
import useCurrentShop from './hooks/useCurrentShop'
import useItinerary from './hooks/useItinerary'
import useTrip from './hooks/useTrip'

import Proptype from 'prop-types'

export default function Step2({ tripId }) {
  const { showItinerary } = useItinerary()
  const { shopInfo } = useCurrentShop()
  const { selectedTrip, cabins } = useTrip(tripId)
  useEffect(() => {
    if(selectedTrip.id) {
      // trackGA4Ecommerce(
      //   'view_item',
      //   {
      //     currency: 'USD',
      //     value: Number(roundPrice(
      //       convertCurrency(selectedTrip.price, selectedTrip.currency, 'USD'),
      //     )),
      //     items: [
      //       {
      //         item_id: shopInfo.id.toString(),
      //         price: Number(roundPrice(
      //           convertCurrency(
      //             selectedTrip.price,
      //             selectedTrip.currency,
      //             'USD',
      //           ),
      //         )),
      //         item_brand: 'PADI',
      //         item_name: shopInfo.title,
      //         item_variant: `${selectedTrip.itinerary.title} / ${moment(
      //           selectedTrip.dateFrom,
      //         )
      //           .utc()
      //           .locale('en')
      //           .format('DD MMM')}-${moment(selectedTrip.dateTo)
      //           .utc()
      //           .locale('en')
      //           .format('DD MMM')}`,
      //         itgem_category: 'PADI Travel',
      //         item_category2: 'Liveaboard',
      //         item_list_name: 'PADI Travel - Liveaboard Listing',
      //         quantity: 1,
      //       },
      //     ],
      //   },
      //   'PADI Travel - Liveaboards',
      // )

      // This can be removed once UA has finally sunset in October 2023.
      trackEcommerce(
        'checkout_step_cabin',
        {
          actionField: {
            step: 1,
          },
          products: [
            {
              id: shopInfo.id,
              price: roundPrice(
                convertCurrency(
                  selectedTrip.price,
                  selectedTrip.currency,
                  'USD',
                ),
              ),
              brand: `${shopInfo.title}|${window.affiliateId}`,
              name: shopInfo.title,
              variant: `${selectedTrip.itinerary.title} / ${moment(
                selectedTrip.dateFrom,
              )
                .utc()
                .locale('en')
                .format('DD MMM')}-${moment(selectedTrip.dateTo)
                .utc()
                .locale('en')
                .format('DD MMM')}`,
              category: 'Liveaboard',
              quantity: 1,
            },
          ],
        },
        'USD',
      )
    }
  }, [selectedTrip, shopInfo])
  return (
    <div className='step2'>
      <ItineraryPopup />
      <div className='main-content mobile-small-padding new-pricing'>
        <div className='itinerary-info'>
          <a
            href='#'
            className='itinerary-title'
            onClick={() => showItinerary()}
          >
            <i className='font-icons route-icon'> </i>
            <span>{selectedTrip.title}: </span>
            <DateFormat date={selectedTrip.startDate} format='DD MMM YYYY' />
          </a>
          <div className='popup-links'>
            <a href='#' onClick={() => showItinerary()}>
              <FormattedMessage
                id='itinerary_details'
                defaultMessage='Itinerary details'
              />
            </a>
            <a href='#' onClick={() => showItinerary('#logistics')}>
              <FormattedMessage
                id='how_to_get'
                defaultMessage='How to get there'
              />
            </a>
          </div>
        </div>
        <h2 className='step-title'>
          <span className='number'>2</span>
          <FormattedMessage
            id='select_your_cabin'
            defaultMessage='Select your cabin'
          />
        </h2>
        <div className='cabins'>
          <Cabins cabins={cabins} selectedTrip={selectedTrip} />
        </div>
      </div>
    </div>
  )
}

Step2.propTypes = {
  tripId: Proptype.string,
}
